export const SET_GROUPS_ROLES = 'SET_GROUPS_ROLES';
export const SET_CURRENT_GROUPS_ROLES_WITH_LEVEL = 'SET_CURRENT_GROUPS_ROLES_WITH_LEVEL';
export const RESET_GROUPS_ROLES = 'RESET_GROUPS_ROLES';
